module.exports = __webpack_public_path__ + "static/media/30.1c9b9b0c.jpg";